import Image from "next/image";
import { useAppContext } from "../../../_context";
import HighlightedString from "../../Misc/HighlightedString";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const Hero = () => {
  const [{ tx }] = useAppContext();
  const heroContent = (
    <>
      <h1>
        <HighlightedString
          text={tx["This won’t be just another job, [we promise]"]}
        />
      </h1>
      <p className="mb-0 text-grey-1">
        {
          tx[
            "If you love sports and technology and want to help build an amazing community, you’re one of us. Come on in."
          ]
        }
      </p>
    </>
  );

  return (
    <>
      <section className="hero-section position-relative mw-1920 mx-auto">
        <div className="overflow-hidden hero-height position-relative">
          <Image
            src="/img/heroes/careers.jpg"
            layout="fill"
            objectFit="cover"
            objectPosition="center"
            unoptimized={true}
            className="w-100"
          />
        </div>
        <div className="hero-text bg-white position-absolute d-none d-md-block">
          {heroContent}
        </div>
      </section>
      <section className="d-md-none">
        <Container>
          <Row>
            <Col className="section-padding-y">{heroContent}</Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Hero;
